import React, {useEffect, useState} from 'react';
import Select, {type SingleValue} from 'react-select';
import {type CompanyOptions} from '../../../../utils/constants';
import styles from './SubordinateCompany.module.scss';
import type {EncompassExternalOrganizationResponse} from '../../models/SubordinateCompany';
import {
  fetchExteralOrganizationApi, postSubOrdinateCompany
} from '../../services/external-organization-service';
import {useMutation} from '@tanstack/react-query';
import Loader from '../Loader/Loader';
import CustomRadioGroup from '../CustomRadioGroup/CustomRadioGroup';
import Modal from '../Modal/Modal';

export interface SubordinateCompanySectionProps {
  tpoId: string;
  loanId?: string | null;
  loanDataFields:any;
}

const SubordinateCompanySection :React.FC<SubordinateCompanySectionProps> = ({tpoId,loanId,loanDataFields}) => {
  const [selectedSubordinate , setSelectedSubordinate] = useState<string>("None");
  const [companyOptions, setCompanyOptions]=useState<CompanyOptions[]>([]);
  const [externalOrgData,setExternalOrgData]=useState<EncompassExternalOrganizationResponse>();
  const [selectedCompany,setSelectedCompany] = useState<SingleValue<CompanyOptions>>();
  const [params,setParams] = useState<any>(null);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const mutation = useMutation({
    mutationFn: (params) => fetchExteralOrganizationApi(params),
    onSuccess: (externalOrg, variables, context) => {
      setExternalOrgData(externalOrg);
    },
  });
  useEffect(() => {
    if(!tpoId) return ;
    else if(tpoId) {
      setParams({tpoId: tpoId, start: 1, limit: 100, orgTypes: "Branch",entities:"Dba"})
    }
  }, [tpoId]);
  const postSubordinateCompany = useMutation({
    mutationFn: (payload) => postSubOrdinateCompany(payload),
  });

  useEffect (() => {
    if(params !== null) {
      mutation.mutate(params);
    }
  }, [params]);

  useEffect(() => {

    if(loanDataFields?.subordinateCompanyForJVA?.companyName !== null && loanDataFields?.subordinateCompanyForJVA?.companyName !== "") {
      // @ts-ignore
      const findCompanyOption = externalOrgData?.[selectedSubordinate]?.[0]?.basicInfo?.childOrganizations?.find(orgData => orgData.entityName === loanDataFields?.subordinateCompanyForJVA?.companyName);
      let newCompanyOption = null;
      if(findCompanyOption) {
        newCompanyOption = {
          label: loanDataFields?.subordinateCompanyForJVA?.companyName,
          value: loanDataFields?.subordinateCompanyForJVA?.companyName
        };
        setSelectedCompany({label:loanDataFields?.subordinateCompanyForJVA?.companyName,value:loanDataFields?.subordinateCompanyForJVA?.companyName})
      }
      // @ts-ignore
      const filterExternalOrgForDropdown= externalOrgData?.[selectedSubordinate]?.[0]?.basicInfo?.childOrganizations?.filter(orgData=>orgData.loginDisabled === false)?.map((orgData):CompanyOptions=> ({label:orgData.entityName,value:orgData.entityName}));

      const updatedCompanyOptionsWithExtOrg = [...(filterExternalOrgForDropdown?.length > 0 ? filterExternalOrgForDropdown : [])];
      const updatedCompanyOptions = [...updatedCompanyOptionsWithExtOrg, newCompanyOption];
      setSelectedSubordinate("encompassExternalOrganizationJV")
      const uniqueCompanyOptions = Array.from(
        new Set(updatedCompanyOptions?.map(option => option?.value))
      )?.map(value => {
        return updatedCompanyOptions.find(option => option?.value === value);
      });
      // @ts-ignore
      setCompanyOptions(uniqueCompanyOptions);

    }else if(loanDataFields?.subordinateCompanyForDBA?.companyName !== null && loanDataFields?.subordinateCompanyForDBA?.companyName !== "" ){
      // @ts-ignore
      const findCompanyOption = externalOrgData?.[selectedSubordinate]?.[0]?.dba?.dbaDetails?.find(orgData => orgData.name === loanDataFields?.subordinateCompanyForDBA?.companyName);
      let newCompanyOption = null;
      if(findCompanyOption) {
        newCompanyOption = {
          label: loanDataFields?.subordinateCompanyForDBA?.companyName,
          value: loanDataFields?.subordinateCompanyForDBA?.companyName
        };
        setSelectedCompany({label:loanDataFields?.subordinateCompanyForDBA?.companyName,value:loanDataFields?.subordinateCompanyForDBA?.companyName})
      }
      const jv_or_dba = selectedSubordinate ==="encompassExternalOrganizationJV" ? "childOrganizations" : "dba";
      // @ts-ignore
      const filterExternalOrgForDropdown= externalOrgData?.[selectedSubordinate]?.[0]?.dba?.dbaDetails?.map((orgData):CompanyOptions=> ({label:orgData.name,value:orgData.name}));

      const updatedCompanyOptionsWithExtOrg = [...(filterExternalOrgForDropdown?.length > 0 ? filterExternalOrgForDropdown : [])];

      const updatedCompanyOptions = [...updatedCompanyOptionsWithExtOrg, newCompanyOption];

      setSelectedSubordinate("encompassExternalOrganizationDBA")
      const uniqueCompanyOptions = Array.from(
        new Set(updatedCompanyOptions?.map(option => option?.value))
      )?.map(value => {
        return updatedCompanyOptions.find(option => option?.value === value);
      });
      // @ts-ignore
      setCompanyOptions(uniqueCompanyOptions);

    }else{
      setSelectedSubordinate("None");
      setSelectedCompany(null)
    }

  }, [loanDataFields,externalOrgData]);

  const onChangeCompany =(changes : any) => {
    setSelectedCompany(changes)
    let filterExternalOrgForDropdown;
    let subOrdinateValue = "None"
    if(selectedSubordinate === "encompassExternalOrganizationJV"){
      subOrdinateValue = "JVA"
      // @ts-ignore
      filterExternalOrgForDropdown= externalOrgData?.[selectedSubordinate]?.[0]?.basicInfo?.childOrganizations?.find((orgData: { companyName: SingleValue<CompanyOptions> | undefined; }):any=> orgData?.entityName=== changes.value);

    }else if(selectedSubordinate === "encompassExternalOrganizationDBA"){
      subOrdinateValue = "DBA"
      // @ts-ignore
      filterExternalOrgForDropdown= externalOrgData?.[selectedSubordinate]?.[0]?.dva?.dbaDetails?.find((orgData: { companyName: SingleValue<CompanyOptions> | undefined; }):any=> orgData?.name=== changes.value);

    }
    if(subOrdinateValue !== "None"){
      // @ts-ignore
      const postSubordinateCompanyPayload =
        {
          "companyType": subOrdinateValue,
          "loanId": loanId,
          "companyName": changes?.value,
          "orgId": filterExternalOrgForDropdown?.organizationId,
          // @ts-ignore
          "companyLegalName": externalOrgData?.[selectedSubordinate]?.[0]?.basicInfo?.companyLegalName,
          // @ts-ignore
          "address": externalOrgData?.[selectedSubordinate]?.[0]?.basicInfo?.address,
          // @ts-ignore
          "phone": externalOrgData?.[selectedSubordinate]?.[0]?.basicInfo?.phone || ""
        }
      // @ts-ignore
      postSubordinateCompany.mutate(postSubordinateCompanyPayload);
    }
  };

  useEffect(() => {
    let filterExternalOrgForDropdown;
    if(selectedSubordinate === "encompassExternalOrganizationJV" ){
      // @ts-ignore
      filterExternalOrgForDropdown = externalOrgData?.encompassExternalOrganizationJV?.[0]?.basicInfo?.childOrganizations?.filter(orgData=> orgData?.loginDisabled === false)?.map((orgData):CompanyOptions=> ({label:orgData.entityName,value:orgData.entityName}));
    }else if(selectedSubordinate === "encompassExternalOrganizationDBA"){
      // @ts-ignore
      filterExternalOrgForDropdown = externalOrgData?.encompassExternalOrganizationDBA?.[0]?.dba?.dbaDetails?.map((orgData):CompanyOptions=> ({label:orgData.name,value:orgData.name}));
    }
    // @ts-ignore
    if(filterExternalOrgForDropdown?.length>0 && selectedSubordinate === "encompassExternalOrganizationJV" ){
      setCompanyOptions([...filterExternalOrgForDropdown]);
      setSelectedCompany(null);

    }else if(filterExternalOrgForDropdown?.length>0 && selectedSubordinate === "encompassExternalOrganizationDBA" ) {
      setCompanyOptions([...filterExternalOrgForDropdown]);
      setSelectedCompany(null);
    }else{
      setSelectedCompany(null);

    }
  }, [selectedSubordinate]);

  if(externalOrgData?.encompassExternalOrganizationDBA?.[0]?.dba === null && externalOrgData?.encompassExternalOrganizationJV?.[0]?.basicInfo?.childOrganizations === null) return null;

  return (
    <div className={styles.SubordinateSection}>
      {postSubordinateCompany.isPending && <Loader />}

      <CustomRadioGroup
        selectedSubordinate={selectedSubordinate}
        setSelectedSubordinate={setSelectedSubordinate}
        loanDataFields={loanDataFields}
        setShowPopup={setShowPopup}
        postSubOrdinateCompany={postSubOrdinateCompany}
        loanId={loanId}

      />
      <Modal show={showPopup} onClose={() => setShowPopup(false)}>
        <p style={{fontSize:'14px',color:"black",marginTop:'10px'}}>
          Please contact your Operations Relationship Manager for further assistance.
        </p>
      </Modal>
      <Select
        id={'companyDropdown'+selectedCompany}
        options={companyOptions?.filter((opt)=>opt?.value)}
        value={selectedCompany === null ? null :{label:selectedCompany?.label,value:selectedCompany?.value}}
        isDisabled={selectedSubordinate === "None"|| selectedSubordinate === ""}
        onChange={(changes)=>onChangeCompany(changes)}
        className={styles.basicSingle}
        name="company"
        classNamePrefix="select"
        placeholder={"Choose Company"}
      />
    </div>
  );
};

export default SubordinateCompanySection;
